import { render, staticRenderFns } from "./CantusMundiBucharest.vue?vue&type=template&id=508792dc&scoped=true&"
import script from "./CantusMundiBucharest.vue?vue&type=script&lang=ts&"
export * from "./CantusMundiBucharest.vue?vue&type=script&lang=ts&"
import style0 from "./CantusMundiBucharest.vue?vue&type=style&index=0&id=508792dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508792dc",
  null
  
)

export default component.exports